import React, { useState, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import Accordion from "../Common/Accordion";
import {
  ServicesSection,
  ServicesHeader,
  CenteredTitle,
  ServicesContent,
  ServicesImage,
} from "./ServicesStyles";

const fadeInUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } } };
const fadeInLeft = { hidden: { opacity: 0, x: -30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } } };
const fadeInRight = { hidden: { opacity: 0, x: 30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } } };

export default function Services({ data = {} }) {
  const { eyebrow = "Services", heading = "", image = "", imageAlt = "", items = [] } = data;
  const [activeAccordion, setActiveAccordion] = useState(null);
  const servicesRef = useRef(null);
  const servicesControls = useAnimation();
  const servicesInView = useInView(servicesRef, { once: true });

  React.useEffect(() => {
    if (servicesInView) servicesControls.start("visible");
  }, [servicesInView, servicesControls]);

  return (
    <ServicesSection ref={servicesRef}>
      <ServicesHeader>
        <motion.div initial="hidden" animate={servicesControls} variants={fadeInUp}>
          <h2>{eyebrow}</h2>
          <CenteredTitle>{heading}</CenteredTitle>
        </motion.div>
      </ServicesHeader>

      <ServicesContent>
        <motion.div initial="hidden" animate={servicesControls} variants={fadeInLeft}>
          <ServicesImage>
            <img src={image} alt={imageAlt} />
          </ServicesImage>
        </motion.div>

        <motion.div initial="hidden" animate={servicesControls} variants={fadeInRight}>
          <Accordion items={items} activeIndex={activeAccordion} onToggle={setActiveAccordion} />
        </motion.div>
      </ServicesContent>
    </ServicesSection>
  );
}
